import React from "react";
import "./index.css";
import AboutImg from "../../assets/aboutus.webp";

const index = () => {
  return (
    <div className="about-us-container">
      <div className="img-container">
        <img className="about-image1" src={AboutImg} alt="About Us" />
        <div class="text-overlay">About Us</div>
      </div>
      <div class="description">
        Capri Xponentia Managers LLP is an India-focused special situations investment platform jointly promoted by the founders of the Capri Group and Xponentia Capital Partners.
        <br />
        <br />
        Capri Stressed Assets Fund (CSAF), a SEBI-registered Category II AIF, focuses on investing in Indian mid-market stressed companies with strong underlying businesses, leveraging structured capital solutions and active turnaround strategies. The Fund has a target corpus of ₹1,000 crore with an additional ₹500 crore green-shoe option. It has received commitments of ₹700 crore to date and is expected to complete its final close on 8 May 2026. The Sponsor, affiliates, and partners have committed ₹450 crore underscoring strong alignment with investors. We are targeting to generate gross IRR of 25%. The Fund’s balance life is 7.5 years from Final close.
         <br /> <br />
        Our primary focus is to work with companies having ‘Good Businesses with Bad Balance Sheets’ in the mid-market segment.
      </div>
    </div>
  );
};

export default index;
